import api from "./api-manager";

const { REACT_APP_API_A39, REACT_APP_RMP_SALESDESK_API_URL, REACT_APP_RMP_APP_ID } = process.env;

export default {
  async getPerformanceList(adsId, date, view) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/performance/list`,
      { adsId, date, view },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async getPerformanceVersus(adsId, baseDate, compareDate, view) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      "/v1/performance/versus",
      { adsId, baseDate, compareDate, view },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },

  async getFBDashboard(ads_account_id, date_preset) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/events/getDashboard`,
      { ads_account_id, date_preset },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },

  async getFBReport(ads_account_id, date_preset) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/events/getRepoting`,
      { ads_account_id: ads_account_id, date_preset: date_preset },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },

  async getFBGraph(pixel_code_id, date_preset) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/events/getGraphStats`,
      { pixel_code_id: pixel_code_id, date_preset: date_preset },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },

  async getGDashboard(ads_account_id, date_preset) {
    const app_id = REACT_APP_RMP_APP_ID;
    const adwords_id = ads_account_id;
    const date_range = date_preset;
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/rads/google-api/dashboard`,
      { app_id, adwords_id, date_range },
      {
        baseURL: REACT_APP_RMP_SALESDESK_API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async getGReport(ads_account_id, date_preset) {
    const app_id = REACT_APP_RMP_APP_ID;
    const adwords_id = ads_account_id;
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/google/getCampaignStats`,
      { app_id: app_id, adwords_id: adwords_id, date_preset: date_preset },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async getGGraph(ads_account_id, date_preset) {
    const app_id = REACT_APP_RMP_APP_ID;
    const adwords_id = ads_account_id;
    const date_range = date_preset;
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/google/get-graph-stats`,
      { app_id: app_id, adwords_id: adwords_id, date_range: date_range },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
};
